getResultsFromLink